import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import AgencyPrefixesList from "./AgencyPrefixesList";
import AgencyPrefixesCreate from "./AgencyPrefixesCreate";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function AgencyPrefixes() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(AgencyPrefixesList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(AgencyPrefixesCreate, null))); } })));
}
export default AgencyPrefixes;
